import React, { useRef } from 'react';
import _ from "lodash";
import { useCommonStore } from '@/store/useCommonStore';

const WscDictMapping = ({ dictName, dictValue }) => {
    const sysdicts = useCommonStore.use.sysdicts();
    if (!dictName || _.isNil(dictValue)) return '--';
    const dictItem = _.find(sysdicts, (item) => item.Name === dictName);
    if (!dictItem) return dictValue;

    // 将 dictValue 转换为布尔类型
    let boolDictValue = dictValue;
    if (dictValue === 't' || dictValue === 'true') {
        boolDictValue = true;
    } else if (dictValue === 'f' || dictValue === 'false') {
        boolDictValue = false;
    }

    const valueItem = _.find(dictItem.Data, (item) => item.code === boolDictValue);
    if (!valueItem) return dictValue;
    return valueItem.name;
}

export default WscDictMapping;